import type { PropsWithChildren, ReactNode } from "react";

interface VideoDetailProps {
	label: string;
	value: ReactNode;
}
export function VideoFact({ label, value }: VideoDetailProps) {
	return (
		<div className="VideometaDetails">
			<span>{label}</span>
			{value}
		</div>
	);
}

export function VideoDetails({ children }: PropsWithChildren) {
	return <div className="VideometaDetails-container">{children}</div>;
}

export function VideoInfoSection({ title, children }: PropsWithChildren<{ title: string }>) {
	return (
		<section className="videoInfoSection">
			<h2 className="videoInfoSection-title">{title}</h2>
			<div className="videoInfoSection-grid">{children}</div>
		</section>
	);
}
